import { focusManager, onlineManager } from '@tanstack/query-core';

import type { AppActivity, NetworkAvailability } from '../ports';

export const networkAvailability: NetworkAvailability = {
  isOnline: () => onlineManager.isOnline(),
  subscribe: (listener) => onlineManager.subscribe(listener),
};

export const appActivity: AppActivity = {
  isActive: () => focusManager.isFocused(),
  subscribe: (listener) => focusManager.subscribe(listener),
};
